import React from 'react'
import ReportParamDate from './ReportParamDate'
import './ReportParam.css'
import { ReportParamValueType } from '../store/store'

type Props = {
  id: string
  type: string
  label: string,
  value: Date | string,
  setParam: (key: string, value: ReportParamValueType) => void
}

function ReportParamInput(props: Props) {  
  function handleChange(value: ReportParamValueType) {
    props.setParam(props.id, value)
  }

  return (
    <div className="report-param">
      <div className="report-param-label">
        <label>{props.label}</label>
      </div>
      <div className="report-param-value">
        {props.type === 'date' && (
          <ReportParamDate value={props.value} id={props.id} onChange={handleChange}/>
        )}
        {props.type !== 'date' && typeof props.value === 'string' &&   (
          <input id={props.id} value={props.value} onChange={(e) => handleChange(e.currentTarget.value)}/>
        )}
      </div>
    </div>
  )
}

export default ReportParamInput
